import { useEffect } from 'react';
import Inputmask from 'inputmask';
export var useInputMask = function useInputMask(inputRef, maskOptions) {
  useEffect(function () {
    if (inputRef.current) {
      Inputmask(maskOptions).mask(inputRef.current);
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);
};